import { useState, useEffect } from 'react';

const ImageViewer = ({ src, alt, className = '' }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Prevent body scrolling when lightbox is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    // Close on Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen]);

    return (
        <>
            {/* Clickable thumbnail */}
            <img
                src={src}
                alt={alt}
                className={`clickable-image ${className}`}
                onClick={() => setIsOpen(true)}
                style={{ cursor: 'pointer' }}
            />

            {/* Lightbox overlay */}
            {isOpen && (
                <div className="lightbox-overlay" onClick={() => setIsOpen(false)}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="lightbox-close-btn"
                            onClick={() => setIsOpen(false)}
                            aria-label="Close lightbox"
                        >
                            &times;
                        </button>
                        <img
                            src={src}
                            alt={alt}
                            className="lightbox-image"
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default ImageViewer;